import React, {useRef, useEffect, useState} from 'react';
import {MapContainer, TileLayer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

// Fix for default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapWithDraw = ({geoJson, onPolygonCreated, language = "en"}) => {
    const mapRef = useRef(null);
    const drawnItemsRef = useRef(new L.FeatureGroup());
    const [mapReady, setMapReady] = useState(false);

    useEffect(() => {
        const map = mapRef.current;
        if (!map || !mapReady) return;

        // Add feature group to map
        map.addLayer(drawnItemsRef.current);

        // Initialize the draw control
        const drawControl = new L.Control.Draw({
            draw: {
                polygon: {
                    allowIntersection: false,
                    drawError: {
                        color: '#b00b00',
                        message: '<strong>Oh, no!<strong> you can\'t draw that!'
                    },
                    shapeOptions: {
                        color: '#bada55'
                    }
                },
                polyline: false,
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false,
            },
            edit: {
                featureGroup: drawnItemsRef.current,
                remove: true
            }
        });

        map.addControl(drawControl);

        setTimeout(() => {
            const polygonBtn = document.querySelector(".leaflet-draw-draw-polygon");
            const editBtn = document.querySelector(".leaflet-draw-edit-edit");
            const deleteBtn = document.querySelector(".leaflet-draw-edit-remove");
            const zoomInBtn = document.querySelector(".leaflet-control-zoom-in");
            const zoomOutBtn = document.querySelector(".leaflet-control-zoom-out");

            if (language === "es") {
                polygonBtn?.classList.add("leaflet-draw-draw-polygon-es");
                editBtn?.classList.add("leaflet-draw-edit-edit-es");
                deleteBtn?.classList.add("leaflet-draw-edit-remove-es");
                zoomInBtn?.classList.add("leaflet-control-zoom-in-es");
                zoomOutBtn?.classList.add("leaflet-control-zoom-out-es");

                polygonBtn?.setAttribute("title", "Dibujar un polígono en el mapa");
                editBtn?.setAttribute("title", "Editar formas");
                deleteBtn?.setAttribute("title", "Eliminar formas");
                zoomInBtn?.setAttribute("title", "Acercar");
                zoomOutBtn?.setAttribute("title", "Alejar");
            } else {
                polygonBtn?.setAttribute("title", "Draw a polygon on the map");
                editBtn?.setAttribute("title", "Edit your shapes");
                deleteBtn?.setAttribute("title", "Delete shapes");
                zoomInBtn?.setAttribute("title", "Zoom In");
                zoomOutBtn?.setAttribute("title", "Zoom Out");
            }
        }, 0);

        // Handle polygon creation
        const handleCreated = (event) => {
            const layer = event.layer;
            drawnItemsRef.current.addLayer(layer);

            const geoJSON = layer.toGeoJSON();
            console.log('Polygon GeoJSON:', geoJSON);

            if (onPolygonCreated) {
                onPolygonCreated(geoJSON);
            }
        };

        map.on(L.Draw.Event.CREATED, handleCreated);

        // Render existing polygons from geoJson prop
        if (geoJson) {
            const geoJsonLayer = L.geoJSON(geoJson).addTo(drawnItemsRef.current);

            // Get the bounds of the layer
            const bounds = geoJsonLayer.getBounds();

            // Fit the map to the bounds
            if (bounds.isValid()) {
                map.fitBounds(bounds);
            }
        }


        return () => {
            if (map) {
                map.off(L.Draw.Event.CREATED, handleCreated);
                map.removeControl(drawControl);
                map.removeLayer(drawnItemsRef.current);
            }
        };
    }, [onPolygonCreated, mapReady, geoJson, language]);

    return (
        <div style={{height: '500px', width: '100%'}}>
            <MapContainer
                center={[39.8283, -98.5795]}
                zoom={4}
                style={{height: '100%', width: '100%'}}
                ref={mapRef}
                whenReady={() => setMapReady(true)}
            >
                <>
                    <TileLayer
                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        attribution="Tiles © Esri"
                    />
                    <TileLayer
                        url="https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
                        attribution="Labels © Esri"
                    />
                </>
            </MapContainer>
        </div>
    );
};

export default MapWithDraw;